import React from 'react'

import { ArrowRightIcon } from '@radix-ui/react-icons'

import { Button, Link } from '../../../../../components'
import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'
import { bootcampsData } from '../../data/bootcampsData'

const FullBootCampSection = () => {
  return (
    <div
      style={{
        background:
          'linear-gradient(7deg, rgba(97, 97, 214, 0.18) 5.54%, rgba(128, 128, 128, 0.00) 94.46%)'
      }}>
      <SectionLayout>
        <SectionHeader className="text-3xl sm:text-5xl font-medium">
          <p>
            <span className="underline decoration-[#FFE14D]">Check out</span>{' '}
            our
          </p>
          <p className="text-primary mt-4">10-month Full-stack bootcamp</p>
        </SectionHeader>
        <SectionContent>
          <div className="bg-[#18181B]/20 w-[518px] rounded-lg border border-primary-light">
            <div className="py-8 px-16 mb-4">
              <h3 className="text-4xl font-bold text-primary-light text-center">
                Learn DSA, Frontend and Backend
              </h3>
            </div>
            <div className="py-8 px-16 bg-white/5 flex flex-row justify-between items-center">
              <div className="flex flex-col gap-4">
                <p>
                  Starting on-{' '}
                  <span className="text-[#FFB300] font-bold">15/01/2024</span>
                </p>
                <p>
                  Duration-{' '}
                  <span className="text-[#FFB300] font-bold">10 Months</span>
                </p>
              </div>
              <div>
                <Link href={bootcampsData.fullstack.explore}>
                  <Button
                    variant="transparent"
                    size={'large'}
                    className="gap-1 items-center justify-center text-primary hover:text-primary hover:bg-white/10">
                    Explore <ArrowRightIcon className="w-5 h-5" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </SectionContent>
      </SectionLayout>
    </div>
  )
}

export default FullBootCampSection
